module.exports = __webpack_public_path__ + "static/media/korea-final2.921ada92.png";